@if (isSiteConditionFieldRoute) {
    <div class="row page-header">
        <div class="col-12">
            <h1>
                Site Condition Change
                <small>Manage site condition changes</small>
            </h1>
        </div>
    </div>
}
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="!showSoftArchived"
                            [deleteText]="'Archive'"
                            [showDuplicate]="false"
                        >
                        </action-toolbar-buttons>
                        @if (showSoftArchived && canEdit) {
                            <button
                                type="button"
                                class="btn btn-sm btn-secondary"
                                (click)="restoreSelected()"
                                [disabled]="!grid.hasItemSelected"
                            >
                                <fa-icon class="d-none d-sm-inline-block" [icon]="faRotateLeft"></fa-icon> Restore
                            </button>
                        }
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export
                            [grid]="mainGrid"
                            [name]="isSiteConditionFieldRoute ? 'Site Condition Change' : 'Pending Change Orders'"
                        ></grid-export>
                        @if (dashboardFilterLabel) {
                            <button
                                type="button"
                                class="btn btn-sm btn-info ml-2"
                                (click)="clearDashboardFilter()"
                                [title]="'Clear dashboard filter: ' + dashboardFilterLabel"
                            >
                                {{ dashboardFilterLabel }}
                                <i class="fas fa-times ms-1"></i>
                            </button>
                        }
                        <button
                            type="button"
                            style="margin-left: auto"
                            class="btn btn-sm btn-secondary ml-2"
                            (click)="toggleShowImported()"
                            [class.btn-primary]="showImported && !showSoftArchived"
                            [disabled]="!!dashboardRecordIds"
                            title="Toggle showing PCOs that have been imported into Vista"
                        >
                            <i
                                class="fas"
                                [class.fa-eye]="!showImported || showSoftArchived"
                                [class.fa-eye-slash]="showImported && !showSoftArchived"
                            ></i>
                            {{ showImported && !showSoftArchived ? 'Hide Imported into Vista' : 'Show Imported into Vista' }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-secondary ml-2"
                            (click)="toggleShowArchived()"
                            [class.btn-primary]="showSoftArchived"
                            [disabled]="!!dashboardRecordIds"
                            title="Toggle showing archived pending change orders"
                        >
                            <i class="fas" [class.fa-eye]="!showSoftArchived" [class.fa-eye-slash]="showSoftArchived"></i>
                            {{ showSoftArchived ? 'Hide Archived' : 'Show Archived' }}
                        </button>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <grid-column-group [grid]="grid"></grid-column-group>
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        [itemFormatter]="mainGridItemFormatter"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="' '"
                            [binding]="'isHot'"
                            [width]="50"
                            [isReadOnly]="true"
                            [visible]="false"
                        >
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                <div style="text-align: center; cursor: pointer" (click)="toggleHot(cell)">
                                    <fa-icon class="d-none d-sm-inline-block" [icon]="faFire"></fa-icon>
                                </div>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job'"
                            [binding]="'job'"
                            [dataMap]="jobDisplayMap"
                            [minWidth]="200"
                            [width]="260"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('job')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Project Manager'"
                            [binding]="'projectManagerName'"
                            [minWidth]="140"
                            [width]="180"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('projectManagerName')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Description'"
                            [binding]="'description'"
                            [minWidth]="200"
                            [width]="'*'"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('description')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Stage'"
                            [binding]="'derivedStage'"
                            [width]="180"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('derivedStage')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Days in Stage'"
                            [binding]="'daysInStage'"
                            [width]="110"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('daysInStage')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Requested/Initiated By'"
                            [binding]="'initiatedBy'"
                            [dataMap]="initiatedByMap"
                            [width]="140"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('initiatedBy')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Date Initiated'"
                            [binding]="'dateInitiated'"
                            [width]="120"
                            [format]="'d'"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('dateInitiated')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Created By'"
                            [binding]="'createdByHrRef'"
                            [dataMap]="vistaUserMap"
                            [width]="160"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('createdByHrRef')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Work Type'"
                            [binding]="'workType'"
                            [dataMap]="workTypeMap"
                            [width]="160"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('workType')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Pricing Method'"
                            [binding]="'pricingMethod'"
                            [dataMap]="pricingMethodMap"
                            [width]="120"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('pricingMethod')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Approximate Cost'"
                            [binding]="'approxCost'"
                            [width]="130"
                            [format]="'c2'"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('approxCost')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Resulted from RFI#'"
                            [binding]="'rfiNumber'"
                            [width]="120"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('rfiNumber')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Owner Acknowledged'"
                            [binding]="'ownerAcknowledgedDate'"
                            [width]="150"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('ownerAcknowledgedDate')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'WCD#'"
                            [binding]="'wcdNumber'"
                            [width]="90"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('wcdNumber')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'PCO# Assigned'"
                            [binding]="'pcoNumber'"
                            [width]="110"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('pcoNumber')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Owner CO#'"
                            [binding]="'ownerCoNumber'"
                            [width]="100"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('ownerCoNumber')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'HB#'"
                            [binding]="'hbNumber'"
                            [width]="120"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('hbNumber')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Waiting On Quotes/Backup'"
                            [binding]="'waitingOnQuotes'"
                            [width]="160"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('waitingOnQuotes')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Estimated HB Cost'"
                            [binding]="'estimatedHbCost'"
                            [width]="130"
                            [format]="'c2'"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('estimatedHbCost')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Estimated HB Price'"
                            [binding]="'estimatedHbPrice'"
                            [width]="130"
                            [format]="'c2'"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('estimatedHbPrice')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'HB Markup'"
                            [binding]="'hbMarkup'"
                            [width]="110"
                            [format]="'c2'"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('hbMarkup')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'HB OH'"
                            [binding]="'hbOh'"
                            [width]="100"
                            [format]="'c2'"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('hbOh')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Proceed to Work'"
                            [binding]="'proceedToWork'"
                            [width]="150"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('proceedToWork')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Proceed to Work by'"
                            [binding]="'proceedToWorkByHrRef'"
                            [dataMap]="vistaUserMap"
                            [width]="160"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('proceedToWorkByHrRef')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Ready for Approval'"
                            [binding]="'readyForApprovalDate'"
                            [width]="150"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('readyForApprovalDate')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Program Mngr Approval'"
                            [binding]="'programMgrApprovalDate'"
                            [width]="150"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('programMgrApprovalDate')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'VP Approval'"
                            [binding]="'vpApprovalDate'"
                            [width]="150"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('vpApprovalDate')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Sent to Owner'"
                            [binding]="'sentToOwnerDate'"
                            [width]="150"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('sentToOwnerDate')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Owner Authorized'"
                            [binding]="'ownerAuthorizedDate'"
                            [width]="150"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('ownerAuthorizedDate')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Owner Executed'"
                            [binding]="'ownerExecutedDate'"
                            [width]="150"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('ownerExecutedDate')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Imported into Vista'"
                            [binding]="'importedIntoVistaDate'"
                            [width]="150"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('importedIntoVistaDate')"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Additional Notes'"
                            [binding]="'notes'"
                            [width]="200"
                            [isReadOnly]="true"
                            [visible]="isPcoGridColumnVisible('notes')"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
</div>
